export default {
    CHAIR: {
        SHOW: '/api/chairs/:chair',
    },
    DOCUMENT: {
        INDEX: '/api/chairs/:chair/documents'
    },
    EVENT: {
        INDEX: '/api/chairs/:chair/events',
        SHOW: '/api/chairs/:chair/events/:event',
    },
    NEWS: {
        INDEX: '/api/chairs/:chair/news',
        SHOW: '/api/chairs/:chair/news/:news',
    },
    PAGE: {
        INDEX: '/api/chairs/:chair/pages',
        SHOW: '/api/chairs/:chair/pages/:page'
    },
    POST: {
        INDEX: '/api/chairs/:chair/posts'
    }
}